(function () {
  var root = document.querySelector('[data-tcb-parts-maintenance-hub]');
  if (!root) return;

  var filterBtns = root.querySelectorAll('[data-pm-filter]');
  var cards = root.querySelectorAll('[data-pm-guide]');
  var emptyEl = root.querySelector('[data-pm-empty]');
  var countEl = root.querySelector('[data-pm-count]');
  var searchInput = root.querySelector('[data-pm-search]');
  var sidebarSearch = root.querySelector('[data-pm-sidebar-search]');
  var searchForm = root.querySelector('[data-pm-search-form]');
  var resetBtn = root.querySelector('[data-pm-reset]');
  var activeFilter = 'all';

  function norm(value) {
    return (value || '').toLowerCase().trim();
  }

  function currentQuery() {
    var hero = searchInput ? norm(searchInput.value) : '';
    var side = sidebarSearch ? norm(sidebarSearch.value) : '';
    return hero || side;
  }

  function applyFilters() {
    var query = currentQuery();
    var visible = 0;

    cards.forEach(function (card) {
      var categories = norm(card.getAttribute('data-categories')).split(/\s+/).filter(Boolean);
      var title = norm(card.getAttribute('data-title'));
      var excerpt = norm(card.getAttribute('data-excerpt'));
      var categoryMatch = activeFilter === 'all' || categories.indexOf(activeFilter) !== -1;
      var searchMatch = !query || title.indexOf(query) !== -1 || excerpt.indexOf(query) !== -1;
      var show = categoryMatch && searchMatch;
      card.hidden = !show;
      if (show) visible += 1;
    });

    if (emptyEl) emptyEl.hidden = visible > 0;
    if (countEl) countEl.textContent = visible + ' guides';
  }

  function setActiveFilter(nextFilter) {
    activeFilter = nextFilter || 'all';
    filterBtns.forEach(function (btn) {
      var btnFilter = btn.getAttribute('data-pm-filter') || 'all';
      var isActive = btnFilter === activeFilter;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    applyFilters();
  }

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setActiveFilter(btn.getAttribute('data-pm-filter'));
      if (btn.classList.contains('tcb-pm-equip')) {
        var target = root.querySelector('#tcb-pm-all-guides');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
      var query = searchInput && searchInput.value.trim();
      if (query && emptyEl && emptyEl.hidden === false) {
        window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=article';
      } else {
        var target = root.querySelector('#tcb-pm-all-guides');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (sidebarSearch) sidebarSearch.addEventListener('input', applyFilters);
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      if (sidebarSearch) sidebarSearch.value = '';
      setActiveFilter('all');
    });
  }

  var applyBtn = root.querySelector('[data-pm-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      applyFilters();
      var target = root.querySelector('#tcb-pm-all-guides');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  applyFilters();
})();
